import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ListItemX2, PanelX1 } from '../../Components/Plugin'
import { Loader, Button } from '../../Components/Shared'
import { ApiCall } from '../../Redux/Actions/ApiCall'
import { useSelector } from 'react-redux'
import moment from 'moment-jalaali'
import { numberWithCommas } from '../../Components/numberWithCommas'
import { urls } from '../../Utils/url';
import CircularProgress from '@material-ui/core/CircularProgress';


const SubscriptionDetails = props => {
	const [load, setLoad] = useState(false);
	const [item, setItem] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const token = useSelector(
		(state) => state.auth.token
	)

	const data = useLocation()

	useEffect(() => {
		if (data.state !== undefined) {
			getSubscriptionDetails(data.state.item.duration, data.state.item.price)
		}
	}, [data.state ? (data.state.item.duration, data.state.item.price) : data])

	function getSubscriptionDetails(duration, price) {
		setIsLoading(true)
		ApiCall(
			'GET',
			`/mobile/subscription-info?duration=${duration}&price=${price}`,
			{},
			"response ->",
			token,
			res => {
				const responsiveData = res.data
				setItem(responsiveData)
				setIsLoading(false)
			},
			err => {
				setIsLoading(false)
			}
		)
	}

	const payment = () => {
		setLoad(true);
		const body = {
			price: data.state.item.price,
			duration: item.duration
		}
		ApiCall(
			'POST',
			urls.buySubscriptions,
			body,
			"",
			token,
			(res) => {
				console.log(res)
				//const url = res.data;
				window.open(res.data);
				//setTimeout(() => window.open(res.data), 1000);
				// var ref = window.open(encodeURI(res.data), '_blank', 'location=yes');
				// ref=window.open(res.data)
			},
			(err) => {
				setLoad(false)
				console.log(err);
			}
		)
	}
	// const backToComponent = (e) =>{
	// console.log('e',e);
	// ApiCall(
		
	// )
	// }





	return (
		<>
			<div className="screenSubscriptionDetails">
				<div>
					<Button to="/subscription" className="_btn">
						<i class="fa fa-angle-right"></i>
						<span>برگشت</span>
					</Button>
				</div>
				{isLoading &&
					<Loader
						className="_loading"
						name="GridLoader"
						size={15}
						color="#f6c244"
					/>
				}
				{!isLoading && item && data.state &&
					<PanelX1 title={data.state.item.title} className="marginBottomNormalize">
						<ListItemX2 label="موبایل" value={item.mobile} />
						<ListItemX2 label="مدت تمدید" value={`${item.duration} ماه`} />
						<ListItemX2 label="هزینه تمدید" value={`${numberWithCommas(data.state.item.price)} ریال`} />
						<ListItemX2 label=" پایان اشتراک پس از تمدید" value={moment(item.extension).format('jYYYY/jMM/jDD')} />

						<div>
							<div className="btn">
								{!load ? <button onClick={payment}>خرید اشتراک</button> : <CircularProgress style={{ color: 'white', height: '20px' }} size={15}/>}
							</div>
						</div>
					</PanelX1>
				}
				{!isLoading && !item && !data.state &&
					<p className="_isEmpty">در حال حاضر جزییاتی از اشتراک موجود نمی باشد .</p>
				}
			</div>
		</>
	)

}


export default SubscriptionDetails
